var map = {
	"./PetIcon.svg": "6aa9",
	"./arrow-down.svg": "76bd",
	"./arrow.svg": "27e4",
	"./arrowLeft.svg": "82aa",
	"./autopayment-icons/autopay1.svg": "70cb",
	"./autopayment-icons/autopay2.svg": "3233",
	"./basket.svg": "93dc",
	"./bg_main.svg": "6354",
	"./card.svg": "3522",
	"./cheackboxArrow.svg": "6994",
	"./checkBox.svg": "7da4",
	"./close.svg": "2930",
	"./closeCaptcha.svg": "50aa",
	"./compliance/error.svg": "45ca",
	"./compliance/ok.svg": "e648",
	"./compliance/pending.svg": "895e",
	"./default.svg": "3f4d",
	"./delete.svg": "2c46",
	"./down-arrow.svg": "a9bb",
	"./exchange.svg": "8eca",
	"./exit.svg": "034f",
	"./eye-opened.svg": "f847",
	"./eye.svg": "796e",
	"./flyable.svg": "6062",
	"./ico-v.svg": "322b",
	"./ico.svg": "7cf1",
	"./items.svg": "f490",
	"./left pag.svg": "57f6",
	"./login.svg": "d625",
	"./mega_neon.svg": "1b91",
	"./missing.svg": "ebee",
	"./neon.svg": "3e5d",
	"./ok.svg": "5a34",
	"./password.svg": "e296",
	"./payment.svg": "c055",
	"./pen.svg": "800f",
	"./pet/addPet.svg": "a5e8",
	"./pet/saleItem.svg": "b756",
	"./pinguin.svg": "4ccf",
	"./plus.svg": "5860",
	"./reload.svg": "4dab",
	"./reviews.svg": "7a1a",
	"./rideable.svg": "48f5",
	"./right pag.svg": "b63e",
	"./right-arrow.svg": "1df7",
	"./rns.svg": "60f6",
	"./search.svg": "22ee",
	"./table.svg": "f0ad",
	"./upload.svg": "ad34"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";